import { isTimeRangeValid } from '@bingads-webui-campaign/segmentation-utilities';

import {
  GENERAL_INSIGHTS_FEATURE_NAMES,
  CAMPAIGN_TYPES,
  getGeneralInsightsPreferences as getPreference,
  saveGeneralInsightsPreferences as savePreference,
} from '@bingads-webui-campaign/competition-auction-insight-preferences';

import {
  PILL_CONTROL,
  GENERAL_INSIGHTS_DATA_TYPES,
} from './consts';

/**
 * Plugin preference for search grid and shopping grid:
 *   Pill control type, Segment: shared
 *   Filter, column chooser: not shared
 */

// ensure fetchPreferenceForGeneralInsights is called first to initalize preferences service
export function getGeneralInsightsPreferences(preferencesService) {
  return getPreference(preferencesService);
}

export function saveGeneralInsightsPreferences(data, preferencesService) {
  savePreference(preferencesService, data);
}

export function getPillControlTypeFromPreferences(preferencesService) {
  const { pillControlType } = getGeneralInsightsPreferences(preferencesService);

  return pillControlType || PILL_CONTROL.overtime;
}

function getGridNameWithPillControlType(preferencesService) {
  const pillControlType = getPillControlTypeFromPreferences(preferencesService);

  return `${GENERAL_INSIGHTS_DATA_TYPES.Grid}_${pillControlType}`;
}

export function getSegmentationData({
  activity,
  appState,
  getSegType,
  preferencesService,
}) {
  const gridNameWithPillControlType = getGridNameWithPillControlType(preferencesService);
  const segType = getSegType(gridNameWithPillControlType);

  if (segType &&
    segType.segmentationType !== 'None'
    && isTimeRangeValid(segType.segmentationType, appState.get('$daterange'))) {
    return segType.segmentationType;
  }
  if (activity) {
    activity.trace(
      `time validation failed, fallback from ${segType && segType.segmentationType} to None`,
      'getSegmentationData'
    );
  }
  return 'None';
}

export function setSegmentationData({
  gridName,
  segType,
  setSegType,
  preferencesService,
}) {
  // need to save different segment choice for summary and overtime for general insight grid.
  const gridNameWithPillControlType = getGridNameWithPillControlType(preferencesService);

  // Save for both pill type and grid
  setSegType(gridNameWithPillControlType, segType);
  // this is to support segment decorator logic.
  setSegType(gridName, segType);
}

export function fetchPreferenceForGeneralInsights({
  campaignType,
  preferencesService,
  getSegPreference,
  fetchSortInfo,
  appState,
  getSegType,
}) {
  let finalCampaignType = campaignType;

  // call getSegPreference second as its dependent on preferences initialize
  return preferencesService.initialize()
    .then(() => getSegPreference(getGridNameWithPillControlType(preferencesService)))
    .then(() => {
      if (finalCampaignType === null) {
        const { selectShoppingCampaignType } = getGeneralInsightsPreferences(preferencesService);
        if (selectShoppingCampaignType === true) {
          // clean the campaign type preference
          saveGeneralInsightsPreferences({
            selectShoppingCampaignType: false,
          }, preferencesService);
          finalCampaignType = CAMPAIGN_TYPES.Shopping;
        } else {
          finalCampaignType = CAMPAIGN_TYPES.Search;
        }
      }
      return fetchSortInfo(GENERAL_INSIGHTS_FEATURE_NAMES[finalCampaignType]);
    })
    .then(({ sortableHeader }) => {
      const result = {
        query: {
          query: {},
        },
      };

      result.query.query.SegmentationTypes = getSegmentationData({
        appState,
        getSegType,
        preferencesService,
      });
      result.query.query.PillControlType = getPillControlTypeFromPreferences(preferencesService);
      result.sortableHeader = sortableHeader;
      return {
        campaignType: finalCampaignType,
        gridConfig: result,
      };
    });
}
